import { ActionIcon, Tooltip, useComputedColorScheme, useMantineColorScheme } from "@mantine/core";
import { IconMoon, IconSun } from "@tabler/icons-react";
import { useMessages } from "../i18n/provider";

export function ThemeToggle() {
  const t = useMessages();
  const { setColorScheme } = useMantineColorScheme();
  const isDark = useComputedColorScheme("light") === "dark";
  const Icon = isDark ? IconMoon : IconSun;
  const action = t(isDark ? "theme.switchToLight" : "theme.switchToDark");

  return (
    <Tooltip label={action} withArrow>
      <ActionIcon
        variant="subtle"
        color="gray"
        size="lg"
        aria-label={action}
        onClick={() => setColorScheme(isDark ? "light" : "dark")}
      >
        <Icon size={18} stroke={1.5} />
      </ActionIcon>
    </Tooltip>
  );
}
